<script setup lang="ts">
    import { watch } from 'vue';
    import { useRiskDataStore } from '../../../stores/riskData';
    import { storeToRefs } from 'pinia';

    const model = defineModel<Record<string, any>[]>();

    const props = defineProps<{
        fieldName: string;
        rules: (string | object)[];
        hasNoneOption: boolean;
        isAdditionalForm: boolean;
        questionText: string;
        helpText: string;
        errorMessage: string;
    }>();

    // Get form ref for field revalidation
    const riskDataStore = useRiskDataStore();
    const { additionalForm, initialForm } = storeToRefs(riskDataStore);
    const form = props.isAdditionalForm ? additionalForm : initialForm;

    // Methods
    const isDisabled = (index:number) => {
        const lastIndex = model.value.length - 1;
        const isNoneSelected = model.value[lastIndex]?.Value;

        return props.hasNoneOption && index !== lastIndex && isNoneSelected;
    };

    // Watchers
    watch(() => model.value.map(option => option.Value), (newValues) => {
        const lastIndex = newValues.length - 1;

        if (props.hasNoneOption && newValues[lastIndex]) {
            for (let i = 0; i < lastIndex; i++) {
            model.value[i].Value = false;
            }
        }

        setTimeout(() => {
            document.querySelectorAll(
                ".radio-form[id='" + props.fieldName + "'] input[name*='" + props.fieldName + "'].is-invalid"
            ).forEach(f => form.value.validateField(f.name));
        }, 100);
    }
);
</script>
 

<template>
    <div class="fieldset">
        <div class="form-row row radio-form" :id="fieldName">
            <div class="label-container col-12 col-md-6">
                <label class="form-label" v-html="questionText"></label>
                <button v-if="helpText" 
                        type="button"
                        class="label-tooltip d-flex px-0 py-2"
                        data-bs-toggle="tooltip"   
                        data-bs-html="true"
                        :data-bs-title="helpText"
                        data-bs-placement="left"
                        data-bs-custom-class="custom-tooltip" tabindex="-1">
                    <img aria-hidden="true" tabindex="0" src="/assets/images/icons/info-circle.svg" class="me-1" />
                    Need help?
                </button>
            </div>

            <div class="radio-row multi-radio col-12 col-md-6" :data-testid="'initial-' + fieldName">
                <v-field v-for="(option, index) in model" :key="index"
                    type="checkbox"
                    :name="fieldName + '.' + option.Name"
                    :rules="rules"
                    v-model="option.Value"
                    :value="true"
                    :unchecked-value="false"
                    v-slot="{ field, meta, errorMessage }">
                    <div class="radio-btn-container" :key="index">
                        <input type="checkbox" class="btn-check btn-checkbox" :name="fieldName + '.' + option.Name" :id="fieldName + '.' + option.Name" autocomplete="off"
                                v-bind="field" :aria-checked="option.Value" :value="true"  tabindex="0" :disabled="isDisabled(index)"
                               :class="{ 'is-invalid' : !meta.valid && meta.validated, 'valid' : meta.valid && meta.validated, 'incomplete' : !meta.valid && !meta.validated, 'dirty': meta.dirty }">
                        <label class="btn radio-btn checkbox" :for="fieldName + '.' + option.Name"
                                :class="{ 'invalid' : !meta.valid && meta.validated, 'is-valid' : meta.valid && meta.validated, 'incomplete' : !meta.valid && !meta.validated, 'dirty': meta.dirty, 
                                        'disabled': isDisabled(index) }">
                            <span class="fakecheckbox"><span class="fas fa-check"></span></span>{{ option.Text }}
                        </label>
                    </div>
                </v-field>
            </div>
        </div>
        <ErrorMessage :name="fieldName" v-if="errorMessage">
            <span class="error-message">{{ errorMessage }}</span>
        </ErrorMessage>
    </div>
</template>